import { render, staticRenderFns } from "./GrantOrForceButton.vue?vue&type=template&id=10fe481c"
import script from "./GrantOrForceButton.vue?vue&type=script&lang=js"
export * from "./GrantOrForceButton.vue?vue&type=script&lang=js"
import style0 from "./GrantOrForceButton.vue?vue&type=style&index=0&id=10fe481c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports